// extracted by mini-css-extract-plugin
export default {"header":"OfferFormHeader_header__XisOz","subHeader":"OfferFormHeader_subHeader__kOPrf"};